var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3995 11.1532C15.3079 11.1532 17.6662 8.8049 17.6662 5.90823C17.6662 3.0124 15.3079 0.664062 12.3995 0.664062C9.49121 0.664062 7.13537 3.0124 7.13537 5.90823C7.13537 7.2499 7.74704 8.22573 7.74704 8.22573L1.3787 14.5674C1.09287 14.8524 0.692871 15.5924 1.3787 16.2757L2.1137 17.0074C2.39954 17.2516 3.11787 17.5932 3.70537 17.0074L4.5637 16.1541C5.42037 17.0074 6.40037 16.5199 6.76787 16.0316C7.37954 15.1782 6.64537 14.3241 6.64537 14.3241L6.89037 14.0799C8.06537 15.2516 9.09454 14.5682 9.46204 14.0799C10.0745 13.2266 9.46204 12.3724 9.46204 12.3724C9.21704 11.8849 8.72704 11.8849 9.33954 11.2749L10.0745 10.5432C10.662 11.0307 11.8704 11.1532 12.4012 11.1532H12.3995Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2378 5.90813C14.2367 6.39421 14.0426 6.85996 13.6982 7.20298C13.3537 7.54599 12.8872 7.73818 12.4011 7.73729C11.915 7.73818 11.4485 7.54599 11.1041 7.20298C10.7597 6.85996 10.5656 6.39421 10.5645 5.90813C10.5649 5.66737 10.6127 5.42906 10.7053 5.20679C10.7978 4.98453 10.9332 4.78267 11.1038 4.61274C11.2743 4.44281 11.4767 4.30813 11.6993 4.21641C11.9219 4.12468 12.1604 4.07769 12.4011 4.07813C12.6419 4.07769 12.8804 4.12468 13.103 4.21641C13.3256 4.30813 13.5279 4.44281 13.6985 4.61274C13.869 4.78267 14.0044 4.98453 14.097 5.20679C14.1895 5.42906 14.2373 5.66737 14.2378 5.90813Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.b224c218a7491dc2f888200c69e5fde6.svg";
export { ForwardRef as ReactComponent };